import { Fragment, useState, useEffect } from 'react';
import '../css/revisionPage.less';
import * as _ from 'lodash';
import Detail from './components/Detail';
import CheckAnswers from './components/CheckAnswers';
import { handlers } from '../helpers/helpers';
import EditAnswer from './components/EditAnswer';
import { useParams, useNavigate } from "react-router-dom";
import { TIMED_SURVEYS } from '../utils/timerConfig';

const RevisionPage = ({ refreshTestName, refreshTimer, refreshInitialTimeStamp }) => {
  const [step, setStep] = useState(
    JSON.parse(localStorage.getItem("currentRevisionStep")) ?
      JSON.parse(localStorage.getItem("currentRevisionStep")) : 1
  );
  const [groupCount, setGroupCount] = useState(
    JSON.parse(localStorage.getItem("userData")) && JSON.parse(localStorage.getItem("userData")).currentRevisionGroup ?
      JSON.parse(localStorage.getItem("userData")).currentRevisionGroup : 0
  );
  const [group, setGroup] = useState();
  const [editAnswerData, setEditAnswerData] = useState(
    JSON.parse(localStorage.getItem("userData")) && JSON.parse(localStorage.getItem("userData")).editAnswerData && JSON.parse(localStorage.getItem("userData")).editAnswerData
  );
  const [scrollPosition, setScrollPosition] = useState(0);
  const { countryCode } = useParams();

  const navigate = useNavigate();
  const userData = JSON.parse(localStorage.getItem("userData"));
  const currentValidationStep = JSON.parse(localStorage.getItem("currentValidationStep"));
  const currentTestStep = JSON.parse(localStorage.getItem("currentTestStep"));
  let userResults;
  let groupsLength

  if (userData && currentValidationStep >= 4 && currentTestStep >= 3) {
    userResults = userData.testsResults;
    groupsLength = userData.revisionGroupsLength ? userData.revisionGroupsLength : 0;
  } else {
    navigate(`/examenes/psicologia/${countryCode}`);
  }

  const filterByTestAndGroup = (testId) => {
    const _tests = userData.tests.filter(test => test.id === testId);
    const _userResults = userResults;
    let filterByTest = _userResults.filter(result => result.testId === testId);
    //a falta de campo order se recorre arreglo de grupos como los trae el servicio para mostrarlos en el mismo orden
    let filterByGroup = [];
    if (_tests && _tests[0] && _tests[0].groups) {
      for (let testGroup of _tests[0].groups) {
        const filterTestResultGroup = filterByTest.filter((test) => test.groupId === testGroup.id);
        filterByGroup.push(filterTestResultGroup.sort((question1, question2) => question1.order - question2.order));
      }
    }
    const groupsLength = Object.keys(filterByGroup).length;

    handlers.handleUserData({ revisionGroupsLength: groupsLength });
    setGroup(Object.values(filterByGroup)[groupCount]);
  };

  const setCurrentStep = (stepName, stepValue) => {
    handlers.handleCurrentStep(stepName, stepValue);
  };

  const updateCurrentGroup = (currentGroup) => {
    handlers.handleUserData({ currentRevisionGroup: currentGroup });
  };

  useEffect(() => {
    if (userData && currentValidationStep >= 4 && currentTestStep >= 3) {
      if (step === 2) {
        window.scrollTo(0, scrollPosition);
      }
      setCurrentStep("currentRevisionStep", step);
      updateCurrentGroup(groupCount);
      filterByTestAndGroup(userData.testId);
    }

  }, [groupCount, step]);

  return (
    <Fragment>
      {
        userData && group && group.length > 0 && step === 1 &&
        <Detail setStep={setStep} />
      }
      {
        userData && group && group.length > 0 && step === 2 &&
        <CheckAnswers
          group={group}
          groupCount={groupCount}
          setGroupCount={setGroupCount}
          setEditAnswerData={setEditAnswerData}
          setScrollPosition={setScrollPosition}
          setStep={setStep}
          userData={userData}
          groupsLength={groupsLength}
          refreshTestName={refreshTestName}
          refreshTimer={refreshTimer}
          refreshInitialTimeStamp={refreshInitialTimeStamp}
          countryCode={countryCode}
          timedSurveys={TIMED_SURVEYS}
        />
      }
      {
        userData && step === 3 &&
        <EditAnswer
          editAnswerData={editAnswerData}
          setStep={setStep}
        />
      }
    </Fragment>
  );
};

export default RevisionPage;